import React from 'react';
import { AuthData } from '../../../context/auth';
import {
	EndorsementData,
	withEndorsementContext,
} from '../../../context/EndorsementProvider';
import { Exposure } from '../../../types/policy';
import AddedExposurePerils from './AddedExposurePerils';
import ExistingExposurePerils from './ExistingExposurePerils';

interface Props {
	authData: AuthData;
	endorsementData: EndorsementData;
}

/**
 * The component that will render either an added or existing exposure's peril list.
 */
const Perils = (props: Props) => {
	const { selectedExposure } = props.endorsementData;

	if (!(selectedExposure as Exposure).displayId) {
		return <AddedExposurePerils />;
	} else {
		return <ExistingExposurePerils />;
	}
};

export default withEndorsementContext<Props>(Perils);
